import { render, staticRenderFns } from "./horizontal-scroll-type-checker.vue?vue&type=template&id=45de51ca&scoped=true&"
import script from "./horizontal-scroll-type-checker.vue?vue&type=script&lang=ts&"
export * from "./horizontal-scroll-type-checker.vue?vue&type=script&lang=ts&"
import style0 from "./horizontal-scroll-type-checker.vue?vue&type=style&index=0&id=45de51ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de51ca",
  null
  
)

export default component.exports